import { makeStyles } from '@material-ui/core/styles';

export function useFormStyles() {
    const useStyles = makeStyles((theme) => ({
        button: {
            color: '#004B97',
            fontSize: '0.95rem',
            padding: '0.5rem 1rem',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        cardHeader: {
            color: '#FFF',
            backgroundColor: '#004B97',
            position: 'sticky',
            top: 0,
            zIndex: 3,
        },
        cardContent: {
            maxHeight: '60vh',
            overflowY: 'overlay' as any,
            overflowX: 'overlay' as any,
            width: '102%',
            minWidth: 0,
            boxSizing: 'border-box',
            '@supports not (overflow: overlay)': {
                overflowY: 'auto',
                overflowX: 'auto',
            },
            // Customização do scrollbar para Chrome/Safari/Edge
            '&::-webkit-scrollbar': {
                height: 8,
                width: 8,
                background: '#f5f5f5',
                borderRadius: 8,
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#bdbdbd',
                borderRadius: 8,
            },
            '&::-webkit-scrollbar-corner': {
                background: '#f5f5f5',
            },
            // Remove setas do scrollbar em alguns navegadores Webkit
            '&::-webkit-scrollbar-button': {
                display: 'none',
                width: 0,
                height: 0,
            },
        },
        cardActions: {
            justifyContent: "flex-end",
            borderTop: '1px solid #F0F0F0',
            position: "sticky",
            bottom: 0,
            background: "#fff",
            zIndex: 2,
        },
        chips: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(3),
        },
        formGroup: {
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing(2),
            alignItems: 'flex-start',
            '& > *': {
                flex: 1,
            },
        },
        formControl: {
            width: '100%',
        },
        textField: {
            color: '#706E7A',
        }
    }));

    const classes = useStyles();

    return {
        classes,
    };
}